/* Carruseles de la home: flechas anterior/siguiente.
   Se muestran solo en computadora (CSS) y solo cuando el carrusel tiene más tarjetas de las que caben. */
(() => {
  const ICON = { prev: 'M15 5l-7 7 7 7', next: 'M9 5l7 7-7 7' };

  const enhance = (rail) => {
    if (rail.dataset.tchArrows) return;
    rail.dataset.tchArrows = '1';

    const wrap = document.createElement('div');
    wrap.className = 'tch-railwrap';
    rail.before(wrap);
    wrap.append(rail);

    const button = (dir) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `tch-arrow tch-arrow--${dir}`;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
      b.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${ICON[dir]}"/></svg>`;
      wrap.append(b);
      return b;
    };
    const prev = button('prev');
    const next = button('next');

    const step = () => {
      const card = rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    };
    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));

    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      wrap.classList.toggle('is-scrollable', max > 2);
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
      // centrar las flechas en la foto de la tarjeta, como en la referencia
      const media = rail.querySelector('.tch-media');
      if (media) wrap.style.setProperty('--tch-arrow-top', `${media.offsetTop + media.offsetHeight / 2}px`);
    };
    rail.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    addEventListener('resize', update);
    addEventListener('load', update);
    update();
  };

  const init = (root = document) => root.querySelectorAll('.tch-rail').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
